import * as actionTypes from './actionTypes';
import * as actions from './index';

export const workflowSend = (workflow, id, type) => {
    return( dispatch => {
        //dispatch(worklowSendStart());
        window.flow.workflowSend(workflow, id, type).then(res => {
            //dispatch(workflowSendSuccess(res));
        }).catch(res => {
            //dispatch(worflowSendFail(res.message));
            dispatch(actions.applicationError(res.message));
        })
    })
} 